<ul class="vertical menu sidebar__menu">
  <li class="sidebar__item">
    <a class="align-middle sidebar__link primary-color" (click)="launchAccount()">
      <div class="grid-x">
        <rav-icon class="cell sidebar__icon" name="person-o"></rav-icon>
        <span class="cell auto align-self-middle">My Account </span>
      </div>
    </a>
  </li>
  <li *ngIf="!router.url.includes('/admin')" class="sidebar__item">
    <a class="align-middle sidebar__link primary-color" routerLink="/contacts">
      <div class="grid-x">
        <rav-icon class="cell sidebar__icon" name="contacts"></rav-icon>
        <span class="cell auto align-self-middle">Contacts </span>
      </div>
    </a>
  </li>
  <li *ngIf="!router.url.includes('/admin')" class="sidebar__item">
    <a class="align-middle sidebar__link primary-color" (click)="onHelpClick()">
      <div class="grid-x">
        <rav-icon class="cell sidebar__icon" name="question-mark"></rav-icon>
        <span class="cell auto align-self-middle">Help </span>
      </div>
    </a>
  </li>
  <li class="sidebar__item">
    <a class="align-middle sidebar__link primary-color" (click)="logout()">
      <div class="grid-x">
        <rav-icon class="cell sidebar__icon" name="power-off"></rav-icon>
        <span class="cell auto align-self-middle">Sign Out </span>
      </div>
    </a>
  </li>
</ul>
